import { render, staticRenderFns } from "./postSwitch.vue?vue&type=template&id=62c26d41&scoped=true&"
import script from "./postSwitch.vue?vue&type=script&lang=js&"
export * from "./postSwitch.vue?vue&type=script&lang=js&"
import style0 from "./postSwitch.vue?vue&type=style&index=0&id=62c26d41&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c26d41",
  null
  
)

export default component.exports